import {bosting, webBased, custom, improving, pastrec, lesstec, psychwel, lackcar,education,ecadmic} from './svgs'

export const neuroCognitive = [
    
    {
        icon:bosting,
        title:"Boosting Cognitive Abilities",
        details:"Enhancing neuro-sensory aspects, cognitive abilities, and scholastic skills for improved quality and agility."
    },
    {
        icon:webBased,
        title:"Web-Based Solutions for Education",
        details:"WiserBee offers a web-based solution tailored for educational institutes."
    },
    {
        icon:custom,
        title:"Customization with Minimal Setup Costs",
        details:"The subscription model allows customization with minimal setup costs."
    },
    {
        icon:improving,
        title:"Improving Well-being and Learning",
        details:"Aimed at improving psychosocial well-being alongside learning outcomes."
    },

]

export const problemsFace = [
    {
        icon:pastrec,
        titleFirst: "Classroom",
        titleSecond:" Complexity",
    },
    {
        icon:lesstec,
        titleFirst: "Less Technological",
        titleSecond:" Advancement",
    },
    {
        icon:psychwel,
        titleFirst: "Psychosocial",
        titleSecond:" wellbeing",
    },
    {
        icon:lackcar,
        titleFirst: "Lack of Career",
        titleSecond:" Mapping",
    },

]
export const componentAI = [
    {
        icon:pastrec,
        title:"Personalized Learner Support",
        details:"Wiser-Adviser offers personalized guidance on study materials and learning strategies for academic success."
    },
    {
        icon:lesstec,
        title:"Classroom Digital Assistant",
        details:"Enhancing group discussions, providing study materials, and creating interactive quizzes for comprehensive learning."
    },
    {
        icon:psychwel,
        title:"Institutional Policy Support",
        details:"Wiser-Adviser streamlines policy management for educational institutions, from academic integrity to campus safety."
    }

]
export const wiserSolution = [
    {
        icon:education,
        title:"Fostering Productivity in Education",
        details:"Tailored solutions foster productivity in education, aiding student well-being, and identifying educational."
    },
    {
        icon:ecadmic,
        title:"Nurturing Academic and Well-being Excellence",
        details:"Holistic education integrates academics, well-being, and tools for mental health to nurture learners in a dynamic world."
    },
]

export const moduleDate = [
    {
        id:"1",
        title:"Personalized Learner Support:",
        ul:"Wiser-Adviser offers personalized assistance to individual learners by:",
        li1:"Analyzing learning patterns and preferences to provide tailored recommendations.",
        li2:"Clarifying difficult concepts and offering explanations in multiple formats (text, audio, video) based on the learner's preferences.",
        li3:"Suggesting study schedules, techniques, and resources tailored to each learner's goals and learning style.",
        li4:"Tracking progress and providing feedback to help learners stay on track and achieve their academic objectives.",
    },
    {
        id:"2",
        title:"Classroom Digital Assistant:",
        ul:"Wiser-Adviser serves as a digital assistant for the entire class by:",
        li1:"Facilitating group discussions and collaborative learning activities.",
        li2:"Generating supplemental study materials such as summaries, diagrams, and practice questions to reinforce classroom lessons.",
        li3:"Conducting interactive quizzes and assessments to gauge student understanding and identify areas for further review.",
        li4:"Providing real-time feedback during classroom activities to encourage active participation and engagement.",
    },
    {
        id:"3",
        title:"Institutional Policy Support:",
        ul:"Wiser-Adviser assists educational institutions in managing and communicating policies by:",
        li1:"Centralizing information about institutional policies, procedures, and guidelines in a user-friendly interface.",
        li2:"Answering frequently asked questions regarding academic integrity, campus resources, student conduct, and administrative procedures.",
        li3:"Sending reminders and notifications to students, faculty, and staff regarding important deadlines, events, and policy updates.",
        li4:"Generating reports and analytics to help administrators monitor compliance, identify trends, and make informed decisions about policy enforcement and revisions.",
    },
]